import * as React from 'react'
import Link from 'gatsby-link'

import Container from '../Container'
import FullScreenSection from '../FullScreenSection'
import * as styles from './Epilogue.module.scss'

const Epilogue = () => (
  <FullScreenSection name="epilogue">
    <Container>
      <div className={styles.featureBox}>
        <h1>Imprint / Impressum</h1>
        <p>
          Angaben gemäß § 5 TMG:
        </p>
        <p>
          Moritz Roth<br/>
          Mooswaldstr. 7<br/>
          79279 Vörstetten<br/>
        </p>
        <p>
          Email: <a href="mailto:hello@mroth.io">hello@mroth.io</a><br/>
          Tel: +49 (0) 162 3230505<br/>
          UStId Nr: DE314362713<br />
        </p>
      </div>
    </Container>
  </FullScreenSection>
)

export default Epilogue



// WEBPACK FOOTER //
// ./src/components/Epilogue/Epilogue.tsx